import React from 'react';

export default function KoobParagraph({
  childClass,
  size = 'lg',
  children,
}: {
  childClass?: string;
  size?: string;
  children?: React.ReactNode;
}) {
  return (
    <p className={`text-${size} font-light text-k-p ${childClass}`}>
      {children}
    </p>
  );
}
